import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Principles from './components/Principles';
import PowerYoga from './components/PowerYoga';
import AiChat from './components/AiChat';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ChatButton from './components/ChatButton';
import './App.css';

function App() {
  const [isNavScrolled, setIsNavScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsNavScrolled(true);
      } else {
        setIsNavScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="App">
      <Navbar isScrolled={isNavScrolled} />
      <Hero />
      <Principles />
      <PowerYoga />
      <AiChat />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
